import * as React from 'react';
import clsx from 'clsx';
import { Theme, makeStyles, createStyles, Card, CardProps } from '@bb-ui/react-library';

export interface PageCardProps extends Omit<CardProps, 'variant'> {
  variant?: 'default' | 'section';
}

export const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    default: {
      marginBottom: '50px',
      padding: theme.spacing(5),
      borderColor: 'transparent',
      minHeight: '250px',
      flex: '0 0 auto',
    },
    section: {
      marginBottom: '20px',
      borderRadius: '4px',
    },
  }),
);

export const PageCard: React.FunctionComponent<PageCardProps> = (props) => {
  const { className, variant = 'default', ...other } = props;
  const classes = useStyles(props);

  return <Card className={clsx({ [classes[variant]]: variant }, className)} {...other} />;
};

export default PageCard;
